import React from 'react'
import PropTypes from 'prop-types'
import {Alert, AlertIcon, AlertDescription} from '@chakra-ui/react'
import {InfoIcon} from '@salesforce/retail-react-app/app/components/icons'

const CartErrorMessage = ({message, fullWidth = false, marginBottom = 0}) => (
    <Alert
        status="error"
        variant="subtle"
        borderRadius="16px"
        bg="#FED7D7"
        py={4}
        px={6}
        alignItems="center"
        border="none"
        width={fullWidth ? '100%' : '439px'}
        height="67px"
        mb={marginBottom}
    >
        <InfoIcon boxSize="20px" color="#FF0000" alignSelf="center" />
        <AlertDescription
            fontStyle="italic"
            fontFamily="Montserrat"
            fontWeight="500"
            lineHeight="1rem"
            fontSize="13px"
            color="#FF0000"
            letterSpacing="1px"
            ml={2}
        >
            {message}
        </AlertDescription>
    </Alert>
)

CartErrorMessage.propTypes = {
    message: PropTypes.string,
    fullWidth: PropTypes.bool,
    marginBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default CartErrorMessage
